import { render, staticRenderFns } from "./examPaperDetail.vue?vue&type=template&id=d362dd6e&scoped=true&"
import script from "./examPaperDetail.vue?vue&type=script&lang=ts&"
export * from "./examPaperDetail.vue?vue&type=script&lang=ts&"
import style0 from "./examPaperDetail.vue?vue&type=style&index=0&id=d362dd6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d362dd6e",
  null
  
)

export default component.exports